<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Situazione Economica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataSituazioneEconomica.fonteRisorseEconomiche }}</span>
                            <b-form-textarea v-else v-model="jsonDataSituazioneEconomica.fonteRisorseEconomiche" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataSituazioneEconomica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    fonteRisorseEconomiche: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataSituazioneEconomica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaSituazioneEconomica: "/rsaschedarelazionesanitariasituazioneeconomica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaSituazioneEconomica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaSituazioneEconomica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaSituazioneEconomicaSuccess, me.resultResponseSchedaRelazioneSanitariaSituazioneEconomicaError);
        },

        resultResponseSchedaRelazioneSanitariaSituazioneEconomicaSuccess(response) {
            let me = this;
            me.jsonDataSituazioneEconomica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaSituazioneEconomicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataSituazioneEconomica = {
                id: null,
                idAccettazione: this.idAccettazione,
                fonteRisorseEconomiche: "",
            };
        },

        onSituazioneEconomica() {
            let me = this;
            me.jsonDataSituazioneEconomica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataSituazioneEconomica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaSituazioneEconomica, me.jsonDataSituazioneEconomica, me.saveSchedaRelazioneSanitariaSituazioneEconomicaSuccessResponse, me.saveSchedaRelazioneSanitariaSituazioneEconomicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaSituazioneEconomicaSuccessResponse() {},
        saveSchedaRelazioneSanitariaSituazioneEconomicaErrorResponse() {
            console.error("Errore nel salvataggio situazione economica :");
        },
    },
};
</script>
